var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResultTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3898 96V85.3333H42.7795V68.8C38.4125 67.8222 34.5142 65.9787 31.0847 63.2693C27.6552 60.56 25.1365 57.1591 23.5287 53.0667C16.8444 52.2667 11.2528 49.3564 6.75382 44.336C2.25484 39.3156 0.00356496 33.4258 0 26.6667V10.6667H21.3898V0H74.8642V10.6667H96.254V26.6667C96.254 33.4222 94.0027 39.312 89.5001 44.336C84.9976 49.36 79.406 52.2702 72.7252 53.0667C71.121 57.1556 68.6041 60.5564 65.1746 63.2693C61.7451 65.9822 57.8451 67.8258 53.4744 68.8V85.3333H74.8642V96H21.3898ZM21.3898 41.6V21.3333H10.6949V26.6667C10.6949 30.0444 11.6753 33.0898 13.636 35.8027C15.5967 38.5156 18.1813 40.448 21.3898 41.6ZM74.8642 41.6C78.0727 40.4444 80.6573 38.5102 82.618 35.7973C84.5787 33.0844 85.5591 30.0409 85.5591 26.6667V21.3333H74.8642V41.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultTrophy);
export default __webpack_public_path__ + "static/media/resultTrophy.640bfa66ef8d24f36c2ee3ce40d941e4.svg";
export { ForwardRef as ReactComponent };